import React from 'react';
import ModooCarList from "../containers/ModooCarList/ModooCarList";

const ModooCarListPage: React.FC = () => {
  return (<ModooCarList />);
};

export default ModooCarListPage;
